import { gql } from "@apollo/client";

export const VALIDATE_CODE = gql`
  mutation validateCode($input: ValidateCodeInput!) {
    validateCode(input: $input) {
      valid
    }
  }
`;
